import { render, staticRenderFns } from "./PhysicalOrderPayment.vue?vue&type=template&id=4e0f516f&scoped=true"
import script from "./PhysicalOrderPayment.vue?vue&type=script&lang=js"
export * from "./PhysicalOrderPayment.vue?vue&type=script&lang=js"
import style0 from "./PhysicalOrderPayment.vue?vue&type=style&index=0&id=4e0f516f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f516f",
  null
  
)

export default component.exports